import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {getApiCallGenerator} from 'Shared/utilities/sagaApiGenerators';
import {SSOResponse} from 'Users/api/apiTypes';
import ssoApi from 'Users/api/ssoApi';
import {changeSSOUrl, sso, SSOAccountActionType} from 'Users/ducks/SSO/ssoAccount';
import {changeAccounts, getAccounts, SSOAccountsActionType} from 'Users/ducks/SSO/ssoAccounts';

export function* ssoUser(action: ReturnType<typeof sso>) {
  const {userId, username, ssoEntityId, encryptedIdentifier} = action.payload;
  const result: AsyncResult<SSOResponse> = yield call(
    ssoApi.getSSOUrl,
    encryptedIdentifier,
    userId,
    username,
    ssoEntityId
  );

  if (E.isRight(result)) {
    yield put(changeSSOUrl(new Loaded(result.right)));
  } else {
    yield put(createSnackbar('An error ocurred during the SSO process. Please try again.'));
  }
}

export function* ssoUserSaga() {
  yield takeLatest(SSOAccountActionType.SSO, ssoUser);
}

export function* getSsoAccounts(action: ReturnType<typeof getAccounts>) {
  const {userId, encryptedIdentifier} = action.payload;

  yield getApiCallGenerator(() => ssoApi.getAccounts(encryptedIdentifier, userId), changeAccounts)(action);
}

export function* getSsoAccountsSaga() {
  yield takeLatest(SSOAccountsActionType.GET_ACCOUNTS, getSsoAccounts);
}

export default function*() {
  yield all([getSsoAccountsSaga(), ssoUserSaga()]);
}
